export default "__VITE_ASSET__ByhCSrh4__"